import styled from 'styled-components';

import { Button } from 'common/interaction';

export const PaginationContainer = styled.div<PaginationContainerProps>`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ type }) => type !== 'blog' ? '6em' : '1em'};
`;

type PaginationContainerProps = {
  type: string;
};

export const PaginationButton = styled(Button)<PaginationButtonProps>`
  width: 2rem;
  height: 2rem;
  border: 1px solid ${({ theme, isCurrentPage }) => isCurrentPage ? theme.colors.primary : theme.colors.gray.border};
  background-color: ${({ theme, isCurrentPage }) => isCurrentPage ? theme.colors.primary : theme.colors.white};
  color: ${({ theme, isCurrentPage }) => isCurrentPage ? theme.colors.white : theme.colors.black};
  padding: 0;
  font-size: 14px;

  //center chevrons
  & div {
    width: auto;
    height: auto;
  }
`;

type PaginationButtonProps = {
  isCurrentPage?: boolean;
};
